// ============================================================
// useStudentFeeInstallments Hooks
// ============================================================

import { useQuery } from '@tanstack/react-query';
import { useSchool } from './useSchool';
import { studentFeeInstallmentsApi } from '@/api/studentFeeInstallments.api';

export function useStudentFeeSummary(studentId, options = {}) {
  const { currentSchool } = useSchool();
  const schoolId = currentSchool?.id;

  return useQuery({
    queryKey: ['studentFeeSummary', studentId, schoolId],
    queryFn: () => studentFeeInstallmentsApi.getFeeSummary(studentId, schoolId),
    enabled: !!studentId && !!schoolId && (options.enabled !== false),
    ...options,
  });
}

export function useStudentInstallments(studentId, options = {}) {
  const { currentSchool } = useSchool();
  const schoolId = currentSchool?.id;

  return useQuery({
    queryKey: ['studentInstallments', studentId, schoolId],
    queryFn: () => studentFeeInstallmentsApi.getStudentInstallments(studentId, schoolId),
    enabled: !!studentId && !!schoolId && (options.enabled !== false),
    ...options,
  });
}
